//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

// exports = modifyTypes;
const gagoSouceTypes = [
    {
        name: "lerc_tile",
        source: require("./gago-source/lerc_tile_source"),
    },
    {
        name: "lercImageByTile",
        source: require("./gago-source/lerc_image_by_tile_source"),
    },
    {
        name: "lerc_v2",
        source: require("./gago-source/lerc_tile_sourcev2"),
    },
    {
        name: "lerc3D-tile",
        source: require("./gago-source/lerc3D_tile_source"),
    },
    {
        name: "lerc_mask",
        source: require("./gago-source/lerc_tile_mask_source"),
    },
    {
        name: "lerc-image",
        source: require("./gago-source/lerc-image-source"),
    },
    {
        name: "ags-dynamic",
        source: require("./gago-source/ags-dynamic-source"),
    },
];

exports.gagoSouceTypes = gagoSouceTypes;
exports.addSourceTypes = function(setType) {
    gagoSouceTypes.forEach(({ name, source }) => {
        setType(name, source);
    });
};
